import { Link } from 'react-router-dom';
import React from 'react';


const CustomLink = ({
    to = "/",
    className,
    children,
    ariaLabel,
    title,
    target,
    onClick
}) => {
    return (
        <Link
            to={to}
            aria-label={ariaLabel}
            title={title}
            className={className}
            target={target}
            onClick={onClick}
        >
            {children}
        </Link>
    );
};

export default CustomLink;